import { Clipboard } from '@angular/cdk/clipboard';
import { Directive, HostListener, Inject, Input, Optional } from '@angular/core';

import { ServiceLocator } from '@summit/core';

import { COPY_TO_CLIPBOARD_HANDLER } from './tokens';

@Directive({ selector: '[summitCopy]' })
export class CopyToClipboardDirective {
  @Input('summitCopy') text: string;
  private clipboard?: Clipboard;
  // @Input('summitCopyOptions') options: CopyConfig = {};

  constructor(@Optional() @Inject(COPY_TO_CLIPBOARD_HANDLER) private token?) {
    this.clipboard = ServiceLocator.injector?.get(Clipboard);
  }

  @HostListener('click', ['$event', 'true'])
  copyEvent(_$event) {
    this.copy(this.text);
  }

  copy(text: string) {
    if (!this.clipboard) {
      return;
    }
    const pending = this.clipboard.beginCopy(text);
    let remainingAttempts = 3;
    const attempt = () => {
      const result = pending.copy();
      if (!result && --remainingAttempts) {
        setTimeout(attempt);
      } else {
        this.token?.(this.text);
        pending.destroy();
      }
    };
    attempt();
  }
}
